import { Outlet, useParams } from "react-router-dom";

import "./Report.scss";

export default function Report(props) {
  let id = useParams()["id"];

  return (
    <div className="report-page">
      <Outlet context={id} />
    </div>
  );
}
